import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const ArrowSmallRight = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<g id="arrowSmallRight" transform="translate(-1138.000000, -369.000000)" fill={color} fillRule="nonzero">
				<polygon
					id="arrowSmallRight"
					transform="translate(1140.379147, 370.958333) scale(-1, 1) rotate(-180.000000) translate(-1140.379147, -370.958333) "
					points="1141.04295 370.593791 1140.37915 369.5 1141.04295 369.5 1142.03791 370.958131 1141.04295 372.416667 1140.37915 372.416667 1141.04295 371.322472 1138.72038 371.322472 1138.72038 370.593791"
				/>
			</g>
		</CustomSVGIcon>
	);
};

ArrowSmallRight.propTypes = {
	color: PropTypes.string,
};

export default ArrowSmallRight;
